<template lang='pug'>
div
  #topbar
  nav#nav
    a#logo(href='https://www.evaair.com')
      img(src='/static/images/logo.png')
    .menu
      a.item(href='/') 首頁
      a.item(href='#spots') 旅展優惠
      a.item.line(@click='lineShare')
        img(src='/static/images/line.png')
      a.item.fb(@click='fbShare')
        img(src='/static/images/fb.png')

  nav#mobile-nav
    .nav-inner
      .nav-overlay(:class='{"is-active": toggleMenu}', @click='toggleMenu=false')
      a.hamburger.hamburger--elastic(:class='{"is-active": toggleMenu}', @click='toggleMenu=!toggleMenu')
        .hamburger-box
          .hamburger-inner
      #logo
        a(href='https://www.evaair.com')
          img(src='/static/images/logo.png')
      .menu(:class='{"is-active": toggleMenu}')
        a.item(href='/') 首頁
        a.item(@click='jumpTo("#spots")') 旅展優惠
        .share
          .inner
            .line(@click='lineShare')
              img(src='/static/images/line.png')
            .fb(@click='fbShare')
              img(src='/static/images/fb.png')
    a.nav-buy(@click='buyAction')
      img(src='/static/images/buy.png')


  .main
    section.sec#top
      .inner
        .slogan-travel 今夏長榮帶你樂遊世界
        .animation-area(ref='area1')

          img.balloon1(src='/static/images/balloon1.png')
          img.balloon2(src='/static/images/balloon2.png')
          img.balloons(src='/static/images/balloons.png')
          img.cloud2(src='/static/images/cloud2.png')
          img.cloud(src='/static/images/cloud.png')
          img.sun(src='/static/images/sun.png')
          img.slogan5(src='/static/images/slogan5.png')
          .slogan-discount.skew
            .title.dark-orange 全航線限時優惠
            .subtitle
              span 最低
              span.small.dark-orange NTS
              span.price.dark-orange 2,999
              span 元
              span.small 起(未稅)
          img.slogan1-2(src='/static/images/slogan1-2.png')
          img.slogan1-1(src='/static/images/slogan1-1.png')
          .tree-wrapper
            img.tree(src='/static/images/tree.png')
            img.wave(src='/static/images/wave-small.gif')

          img.wave2(src='/static/images/wave-small.gif')
          img.plane.hover-zoom(src='/static/images/plane.png')
          img.buy.center.hover-zoom(src='/static/images/buy.png', @click='buyAction')




        // img.half_cloud(src='/static/images/half_cloud.png')
    section.sec#spots
      .inner
        .animation-area(ref='area2')
          .slider-wrapper.center
            SaleSlider.spot-slider

          img.chair(src='/static/images/chair-small.gif')
          img.stuff(src='/static/images/stuff-small.gif')
          img.slogan6.center(src='/static/images/slogan6+7.png')

      .inner-mobile
        img.slogan6-mobile.center(src='/static/images/slogan6-mobile.png')
        .spot.mobile-spot(
          :class='`mobile-spot-${i}`',
          v-for='(spot, i) in pagedSpots',
          @click='link(spot.linkURL, spot.gaCat)')
            img(:src='`/static/images/${spot.hoverImage}`')
        .spot.control
          .wrapper
            img.lastPage(src='/static/images/last-page.png', :class='{"hide": spotPage === 0}', @click='spotPage -= 1')
          .wrapper
            img.nextPage(src='/static/images/next-page.png', :class='{"hide": spotPage === 2}', @click='spotPage += 1')


      img.quad_cloud(src='/static/images/quad_cloud.png')
    section.sec#footer
      .inner
        .animation-area
          .white-row
          img.donut(src='/static/images/donut.png')
          img.wave(src='/static/images/wave-small.gif')
          img.more.center.hover-zoom(src='/static/images/more.png', @click='link("https://www.evaair.com/zh-tw/flight/2019summertravel.html?utm_source=tw_website&utm_medium=link&utm_campaign=2019summertravel&utm_content=fare", "more")')
          img.icecream(src='/static/images/icecream.png')
</template>

<script>
const TIMES = [1.8, 2.5, 3];
const TweenMax = window.TweenMax;
import SaleSlider from './SaleSlider.vue'
import spots from '../spots';
import { setTimeout } from 'timers';

export default {
  name: 'Home',
  components:{
    SaleSlider,
  },
  data() {
    return {
      toggleMenu: false,
      spots,
      spotPage: 0,
      spotPageSize: 5
    }
  },
  computed: {
    pagedSpots() {
      const startIndex = this.spotPage * this.spotPageSize
      return this.spots.slice(startIndex, startIndex + this.spotPageSize)
    },
  },
  methods: {
    link(linkURL, gaCat) {
      console.log('ga send', gaCat)
      gtag('event', 'click', {
        'event_category' : gaCat
      });
      window.open(linkURL);
    },
    jumpTo(id) {
      this.toggleMenu = false
      location.href += id
    },
    lineShare() {
      console.log('ga send lineshare')
      gtag('event', 'click', {
        'event_category' : 'lineshare'
      });
      // var url = "http://line.naver.jp/R/msg/text/?";
      // url += encodeURIComponent(document.title) + "%0D%0A" + encodeURIComponent("http://2019summer.evaair.com");
      const url = `https://lineit.line.me/share/ui?url=http://2019summer.evaair.com&text=${document.title}`
      window.open(url)
    },
    fbShare() {
      console.log('ga send fbshare')
      gtag('event', 'click', {
        'event_category' : 'fbshare'
      });
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("http://2019summer.evaair.com")}`)
    },
    buyAction() {
      console.log('ga send calltoaction')
      gtag('event', 'click', {
        'event_category' : 'calltoaction'
      });
      this.link("https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare")
    },
    animation1(delay = 0, duration = TIMES[0]) {
      TweenMax.from('.slogan1-1', duration, {
        scale: 0,
        delay,
        ease: Bounce.easeOut
      })
      TweenMax.from('.slogan1-2', duration, {
        scale: 0,
        delay,
        ease: Bounce.easeOut
      })
      TweenMax.from('.slogan5', duration, {
        scale: 0,
        delay,
      })

    },
    animation2(delay = TIMES[0], duration = 0.5) {
      const plane = document.getElementsByClassName('plane')[0]
      const buy = document.getElementsByClassName('buy')[0]

      TweenMax.from('.slogan-discount', duration, {
        x: -200,
        delay,
        ease: Power2.easeOut,
        opacity: 0
      })
      TweenMax.from('.buy', duration, {
        y: 300,
        delay,
        ease: Power2.easeOut,
        opacity: 0
      })
      TweenMax.from('.plane', 3*duration, {
        x: plane.offsetWidth + plane.offsetWidth,
        y: 300,
        delay: TIMES[2],
        opacity: 0
      })
    },
    animation3(delay = TIMES[1] , duration = 1.5) {
      const sun = document.getElementsByClassName('sun')[0]
      const cloud = document.getElementsByClassName('cloud')[0]
      const cloud2 = document.getElementsByClassName('cloud2')[0]
      const balloon1 = document.getElementsByClassName('balloon1')[0]
      const balloon2 = document.getElementsByClassName('balloon2')[0]
      const balloons = document.getElementsByClassName('balloons')[0]
      const wave2 = document.getElementsByClassName('wave2')[0]
      const donut = document.getElementsByClassName('donut')[0]
      const treeWrapper = document.getElementsByClassName('tree-wrapper')[0]
      const tree = document.getElementsByClassName('tree')[0]
      const slogan6 = document.getElementsByClassName('slogan6')[0]

      const slowMotionDuration = 3;
      const slowMotionSpeed = 4;

      new TweenMax.from([treeWrapper, wave2], duration, {
        opacity: 0,
        ease: Power2.easeOut,
        delay
      })

      new TimelineMax().add([
        new TweenMax.from(sun, duration, {
          y: 80,
          opacity: 0,
          ease: Power2.easeOut,
          delay
        }),
        new TweenMax.from(sun, slowMotionDuration, {
          scale: 1.1,
          ease: Power2.easeInOut,
          yoyo: true,
          repeat: -1
        })
      ], 'sequence')

      new TimelineMax().add([
        new TweenMax.from(cloud, duration, {
          // x: - cloud.offsetWidth,
          opacity: 0,
          ease: Power2.easeOut,
          delay
        }),
        new TweenMax.from(cloud, slowMotionDuration, {
          x: 30*slowMotionSpeed,
          repeat: -1,
          ease: Power0.easeOut,
          yoyo: true
        }),
      ], 'sequence')

      new TimelineMax().add([
        new TweenMax.from(cloud2, duration, {
          opacity: 0,
          ease: Power2.easeOut,
          delay
        }),
        new TweenMax.from(cloud2, slowMotionDuration, {
          x: -30*slowMotionSpeed,
          repeat: -1,
          ease: Power0.easeOut,
          yoyo: true
        }),
      ], 'sequence')

      new TimelineMax().add([
        new TweenMax.from(balloon1, duration, {
          opacity: 0,
          ease: Power2.easeOut,
          delay
        }),
        new TweenMax.from(balloon1, slowMotionDuration, {
          y: 10*slowMotionSpeed,
          repeat: -1,
          ease: Power0.easeOut,
          yoyo: true
        }),
      ], 'sequence')

      new TimelineMax().add([
        new TweenMax.from(balloon2, duration, {
          opacity: 0,
          ease: Power2.easeOut,
          delay
        }),
        new TweenMax.from(balloon2, slowMotionDuration, {
          y: 10*slowMotionSpeed,
          repeat: -1,
          ease: Power0.easeOut,
          yoyo: true
        }),
      ], 'sequence')


      new TimelineMax().add([
        new TweenMax.from(balloons, duration, {
          opacity: 0,
          ease: Power2.easeOut,
          delay
        }),
        new TweenMax.from(balloons, slowMotionDuration, {
          y: 10*slowMotionSpeed,
          repeat: -1,
          ease: Power0.easeOut,
          yoyo: true
        }),
      ], 'sequence')

      new TweenMax.from(donut, 1.5*slowMotionDuration, {
        rotation: 360,
        ease: Power0.easeNone,
        repeat: -1,
        delay
      })


      new TweenMax.from(tree, 0.5*slowMotionDuration, {
        rotation: -15,
        transformOrigin: "left bottom",
        ease: Power0.easeNone,
        repeat: -1,
        yoyo: true,
      })

    },
    updateMobileSpot() {
      this.$nextTick(() => {
        TweenMax.from(`.mobile-spot`, .3, {
          opacity: 0,
          ease: Power4.easeIn
        })
      })
    }
  },
  mounted() {
    $('.hover-zoom').each((index, ele) => {
      ele.zoom = new TweenMax.to(ele, .3, {
        paused: true,
        scale: 1.05
      })
    })
    $('.hover-zoom').hover(function() {
      this.zoom.play()
    }, function() {
      this.zoom.reverse()
    })


    const isMobile = $(window).width() < 767
    ///iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const delay = isMobile ? 2000 : 0;
    setTimeout(() => {
      $('#global-spinner').hide()
      this.$nextTick(() => {
        this.animation1();
        this.animation2();
        this.animation3();
      })
    }, delay)


  },
  created() {
    window.app = this
  },
  watch: {
    spotPage() {
      this.updateMobileSpot()
    }
  }
}
</script>
